import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDate',
  standalone: false,
})
export class FormatDatePipe implements PipeTransform {
  transform(value: string | Date, conSecondi = false): string {
    if (!value) return '';

    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    const giorno = String(date.getDate()).padStart(2, '0');
    const mese = String(date.getMonth() + 1).padStart(2, '0');
    const anno = date.getFullYear();

    const ore = String(date.getHours()).padStart(2, '0');
    const minuti = String(date.getMinutes()).padStart(2, '0');

    if (conSecondi) {
      const secondi = String(date.getSeconds()).padStart(2, '0');
      return `${giorno}-${mese}-${anno} ${ore}:${minuti}:${secondi}`;
    }

    return `${giorno}-${mese}-${anno} ${ore}:${minuti}`;
  }
}
